import "./HowItWorks.module.css";
import Header from "@/reusable_sections/Header";
import HowItWorks3StepProcess from "./sections/HowItWorks3StepProcess";
import Footer from "@/reusable_sections/Footer";
export default function HowItWorksPage() {
  return <div>
      <Header />
      <HowItWorks3StepProcess />
      <Footer />
    </div>;
}